function CompanyFormHeader({ isEdit }) {
  return (
    <div className="mb-2">
      <h1 className="text-3xl font-bold text-foreground">
        {isEdit ? "Edit Company" : "Create New Company"}
      </h1>
      <p className="text-muted-foreground mt-1 text-base">
        {isEdit
          ? "Modify existing company details and branding settings."
          : "Fill in the company details below to create a new profile."}
      </p>
    </div>
  );
}

export default CompanyFormHeader;
